
import CalendarRemove from "../../../assets/filled/CalendarRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CalendarRemoveIcon({ className, dataTestid = "CalendarRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CalendarRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
